import React from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";

import { Author } from "./author.js";
import { SectionName } from "./section-name.js";
import {ReviewRating} from "@quintype/components";

function StoryList(props) {
  return !props.stories ? null :  <div className="story-list">
    {props.stories.map((storyObj, index) => {
        // The `props.story` can be an item from items of a collection or a story itself.
        // assigning it accordinlgy.
        const story = storyObj && storyObj.type === 'story' && storyObj.story ? storyObj.story : storyObj;
        return story && <StoryListItem story={story} key={index} config={props.config}></StoryListItem>
      }
    )}
  </div>
}

function StoryListItem({story, config}) {
  const author = {
    name: get(story, ['authors', 0, 'name'], story['author-name']),
    id: get(story, ['authors' , 0, 'id'] , story['author-id'])
  };
  const isReviewStory = story["story-template"] === 'review';

  return (
    <Link href={"/" + story.slug }>
      {
        config && config.section &&
        <SectionName hideLink={true} name={story.sections[0]['display-name'] || story.sections[0]['name']} section={story.sections[0]} />
      }
      <h2 className="story-list__heading"><bdi dangerouslySetInnerHTML={ {__html: story.headline }} ></bdi></h2>
      {isReviewStory && <ReviewRating value={get(story, ['metadata','review-rating', 'value'], '0')} />}
      <Author config={config} author={author}/>
    </Link>
  )
}

export { StoryList };
export { StoryListItem };
